/* You must register this file at "website\src\i18n\fa-ir" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    transactions: {
        menu: {
            index: 'تراکنش‌ها',
            incoming: 'ورودی',
            outgoing: 'خروجی',
            list: 'تاریخچه'
        },
        table_titles: {
            id: 'شناسه',
            side: 'جهت',
            rebit_account: 'حساب ربیت',
            payer_account: 'حساب پرداخت‌کننده',
            payment_details: 'جزئیات پرداخت',
            payer: 'پرداخت‌کننده',
            payee: 'دریافت‌کننده',
            payer_name: 'نام پرداخت‌کننده',
            payer_account_holder: 'دارنده حساب پرداخت‌کننده',
            amount: 'مقدار',
            currency: 'ارز',
            transfer_reference: 'مرجع انتقال',
            match_code: 'کد تطابق',
            payment_method: 'روش پرداخت',
            bank_date: 'تاریخ',
            registered_date: 'تاریخ ثبت رکورد',
            references: 'مراجع',
            description: 'توضیحات',
            status: 'وضعیت',
            txid: 'TXID',
            operator: 'اپراتور',
            setting: 'ویرایش / حذف',
        },
        edit: 'ویرایش تراکنش',
        id_document: 'سند هویت',
    }
}
